import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import CustomBreadCrumbs from "../components/ReuseableCompos/CustomBreadCrumbs";
import CustomJumbotron from "../components/ReuseableCompos/CustomJumbotron";
import SEO from "components/Seo";

const createBreadCrumbTranslations = {
  events: {
    events: {
      title: "sections_events_title",
      desc: "sections_events_desc",
      breadcrumb: "sections_events",
    },
    create: {
      title: "new_event",
      desc: "new_event_desc",
      breadcrumb: "new_event",
    },
  },
  fundraisers: {
    fundraisers: {
      title: "sections_fundraisers_title",
      desc: "sections_fundraisers_desc",
      breadcrumb: "sections_fundraisers",
    },
    create: {
      title: "new_fundraiser",
      desc: "lorem_ipsum_40",
      breadcrumb: "new_fundraiser",
    },
  },
};
const CreateLayout = ({ children }) => {
  const { t } = useTranslation("common");
  const router = useRouter();
  const secondRoute = router.route.split("/")[1];
  const getBreadcrumbTranslation = (title = secondRoute) =>
    t(createBreadCrumbTranslations[secondRoute]?.[title]?.breadcrumb);

  const currentTranslation =
    createBreadCrumbTranslations[secondRoute][router.route.split("/")[2]];
  const title = currentTranslation.title;
  const desc = currentTranslation.desc;

  return (
    <>
      <SEO title={t(title)} description={t(desc)} />
      <CustomJumbotron
        p="py-4"
        breadCrumbM="my-0"
        m="mt-0"
        className="mt-0 ps-2 ps-sm-0 border-bottom"
        title={t(title)}
        desc={t(desc)}
        customBreadCrumbs={
          <CustomBreadCrumbs
            transformedLabel={(title) => {
              return getBreadcrumbTranslation(title);
            }}
          />
        }
      />
      <div className="container">
        <div className="mt-4">{children}</div>
      </div>
    </>
  );
};

export default CreateLayout;
